export { default as MarketShiftAlignmentRules } from './marketShiftAlignmentRules.container';
